/* eslint-disable react/jsx-props-no-spreading */

import { Box, Button, ButtonProps } from '@chakra-ui/react';

export default function LinearGradientBorderButton(props: ButtonProps) {
  const { children, ...buttonProps } = props;

  return (
    <Box
      position="relative"
      display="inline-block"
      padding="2px"
      borderRadius="6px"
      background="linear-gradient( to right, #FC9AB4, #D860F2)"
      width="full"
    >
      <Button
        {...buttonProps}
        backgroundColor="white"
        borderRadius="4px"
        paddingY={2}
        paddingX={4}
        fontWeight={500}
        width="100%"
        height="100%"
        _hover={{ backgroundColor: 'white' }}
      >
        {children}
      </Button>
    </Box>
  );
}
